import { ButtonProps, ButtonType, ButtonWidget, Img, InteractionState } from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~common/utilities/ImgUrl';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { Messages } from '../../../codegen/Localize';
import { PageHeaderStyles } from '../layout/PageHeaderStyles';

import cssVar = PageHeaderStyles.CssVariables.cssVar;
import CssVariables = PageHeaderStyles.CssVariables;

const DEFAULT_ICON_PATH = imgPath('spaces_header_device_preview.svg');
const ACTIVE_ICON_PATH = imgPath('spaces_header_device_preview_active.svg');
const DEFAULT_ICON_PATH_2020 = imgPath('spaces_header_device_preview_2020_regular.svg');

function getPreviewButtonContent(displayOnlyIcons: boolean): ((state: InteractionState) => JSX.Element) {
  return (state: InteractionState): JSX.Element => {
    const buttonText = Messages.previewDeviceLayouts();

    const iconSize = cssVar(CssVariables.headerIconSize);

    const iconStyle = displayOnlyIcons? PageHeaderStyles.iconOnlyButton : PageHeaderStyles.iconForTextButton;

    const imgProps: React.ImgHTMLAttributes<HTMLImageElement> = {
      draggable: false,
      height: iconSize,
      width: iconSize,
      src: FeatureFlags.vizToolbarRedesignEnabled
        ? DEFAULT_ICON_PATH_2020 // from the design the icon is the same for hover and regular states
        : (state.hover ? ACTIVE_ICON_PATH : DEFAULT_ICON_PATH),
      style: iconStyle
    };

    const backgroundColor = FeatureFlags.vizToolbarRedesignEnabled
      ? {backgroundColor: (state.hover ? cssVar(CssVariables.headerBackgroundHoverColor) : 'transparent')}
      : null;

    return (
      <div className={PageHeaderStyles.TextButton} style={backgroundColor}>
        <Img {...imgProps} alt=""/>
        {!displayOnlyIcons && buttonText }
      </div>
    );
  };
}

export function DevicePreviewButton(props: DevicePreviewButton.Props):
  React.ReactElement<DevicePreviewButton.Props> {
    const { handleClick, displayOnlyIcons } = props;

    const buttonStyle = {
      display: 'inline-block',
      cursor: 'pointer'
    };

    const testId = 'toggle-device-preview-mode';

    const iconButtonProps: ButtonProps = {
      buttonType: ButtonType.IconOutline,
      getContent: getPreviewButtonContent(displayOnlyIcons),
      testId: testId,
      handleClick: handleClick,
      style: buttonStyle,
      title: Messages.deviceLayoutsTooltip()
    };

    return (
      <ButtonWidget {...iconButtonProps} />
    );
  }

export namespace DevicePreviewButton {
  export interface Props {
    readonly handleClick: () => void;
    readonly displayOnlyIcons: boolean;
  }
}
